module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-scene"
  }, [_c('el-form', {
    ref: "sceneData",
    staticClass: "edit-scene-form",
    attrs: {
      "model": _vm.sceneData,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sceneData.name),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "name", $$v)
      },
      expression: "sceneData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Type",
      "prop": "type_id"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.sceneData.type_id),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "type_id", $$v)
      },
      expression: "sceneData.type_id"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('el-option', {
      key: type.id,
      attrs: {
        "label": type.name,
        "value": type.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Light Percentage",
      "prop": "percentage"
    }
  }, [_c('el-slider', {
    attrs: {
      "show-input": ""
    },
    model: {
      value: (_vm.sceneData.percentage),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "percentage", $$v)
      },
      expression: "sceneData.percentage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Light Consumption (kW)",
      "prop": "consumption"
    }
  }, [_c('el-slider', {
    attrs: {
      "max": 200,
      "step": 0.1,
      "show-input": ""
    },
    model: {
      value: (_vm.sceneData.consumption),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "consumption", $$v)
      },
      expression: "sceneData.consumption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Device",
      "prop": "power_relay",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Device"
    },
    model: {
      value: (_vm.sceneData.power_relay),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "power_relay", $$v)
      },
      expression: "sceneData.power_relay"
    }
  }, _vm._l((_vm.devices), function(device) {
    return _c('el-option', {
      key: device.id,
      attrs: {
        "label": device.name,
        "value": device.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.getDeviceType(_vm.sceneData.power_relay) !== 4) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Logical",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Logical no",
      "disabled": _vm.sceneData.power_relay <= 0
    },
    model: {
      value: (_vm.sceneData.logical_no),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "logical_no", $$v)
      },
      expression: "sceneData.logical_no"
    }
  }, _vm._l((_vm.logicals), function(logical) {
    return _c('el-option', {
      key: logical.logical_no,
      attrs: {
        "label": logical.logical_no,
        "value": logical.logical_no
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Function",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Function"
    },
    model: {
      value: (_vm.sceneData.function_id),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "function_id", $$v)
      },
      expression: "sceneData.function_id"
    }
  }, _vm._l((_vm.functions), function(f) {
    return _c('el-option', {
      key: f.id,
      attrs: {
        "label": f.name,
        "value": f.id
      }
    })
  }))], 1)], 1) : _c('div', [_c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Group",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Group no",
      "disabled": _vm.sceneData.power_relay <= 0
    },
    model: {
      value: (_vm.sceneData.logical_no),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "logical_no", $$v)
      },
      expression: "sceneData.logical_no"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('el-option', {
      key: group.id || group.groupid,
      attrs: {
        "label": group.name,
        "value": group.id || group.groupid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Scene",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "CB Scene"
    },
    model: {
      value: (_vm.sceneData.function_id),
      callback: function($$v) {
        _vm.$set(_vm.sceneData, "function_id", $$v)
      },
      expression: "sceneData.function_id"
    }
  }, _vm._l((_vm.cbScenes), function(scene) {
    return _c('el-option', {
      key: scene.id,
      attrs: {
        "label": scene.name,
        "value": scene.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('sceneData')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d3e61c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Scenes/EditScene.vue
// module id = 1036
// module chunks = 5